import React, { useState } from 'react';
import { generateLouTemplate, GenerateLouTemplateBody } from 'src/app/modules/AgencyCampaign/network/approvalCrud';
import { Dialog, DialogContent, DialogContentText } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { useIntl } from 'react-intl';
interface Props {
  remarksItem: any;
  campaignObjId: string | undefined;
}
/** LOU html template: click to display the html in dialog */
export const LouTemplate: React.FC<Props> = ({ remarksItem, campaignObjId }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const [open, setOpen] = useState<boolean>(false);
  const [louHtml, setHtml] = useState<string>(`<span> ${Translation('common.loading')} </span>`);

  const getLOU = (item: any) => {
    const param: GenerateLouTemplateBody = {
      templateId: item?.templateId,
      id: campaignObjId || '',
    };
    if (!param.id || !param.templateId) {
      return;
    }
    generateLouTemplate(param)
      .then((html) => {
        setHtml(html);
      })
      .catch((err) => {
        console.log('lou error: ', err);
        const errTips = `<span> ${Translation('common.serviceError')} </span>`;
        setHtml(errTips);
      });
  };

  const openRemark = () => {
    setOpen(true);
    getLOU(remarksItem);
  };

  const toggleOpen = () => setOpen(!open);

  return (
    <>
      <div style={louItem} onClick={openRemark}>
        {remarksItem.templateId}
      </div>
      <Dialog
        open={open}
        onClose={toggleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={dialogHeader} onClick={toggleOpen}>
          <CloseOutlined />
        </div>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div dangerouslySetInnerHTML={{ __html: louHtml }} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

const louItem = { textDecoration: 'underline', cursor: 'pointer' };
const dialogHeader = {
  padding: 16,
  textAlign: 'right' as const,
  borderBottom: '1px solid #ccc',
};
